import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot } from "vue"
import _imports_0 from '@/assets/logo.png'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "logo"
}, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "logo"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", null, "标养室智慧运营平台", -1)
const _hoisted_4 = { style: { flex: 1 } }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.classNames)
  }, [
    (_ctx.isMobile)
      ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          class: _normalizeClass(`${_ctx.baseClassName}-logo`)
        }, [
          _createVNode(_component_router_link, { to: { name: 'index' } }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          })
        ], 2))
      : _createCommentVNode("", true),
    (_ctx.layout === 'mix' && !_ctx.isMobile)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(`${_ctx.baseClassName}-logo`)
        }, [
          _createVNode(_component_router_link, { to: { name: 'index' } }, {
            default: _withCtx(() => [
              _hoisted_2,
              _hoisted_3
            ]),
            _: 1
          })
        ], 2))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _renderSlot(_ctx.$slots, "rightContent")
  ], 2))
}